/**
 * Rounds to 2 decimal places, dropping the decimals entirely when the rounded
 * value is a whole number (e.g. 9.999 -> "10", 12.5 -> "12.50").
 * Returns "" for blank or non-numeric values.
 */
const formatUpToTwoDecimalPlaces = (value, { useGrouping = false } = {}) => {
  if (value === null || value === undefined || value === "") return "";

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return "";

  const roundedValue =
    Math.round((numericValue + Number.EPSILON) * 100) / 100 || 0;
  const fractionDigits = Number.isInteger(roundedValue) ? 0 : 2;

  return new Intl.NumberFormat("en-US", {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    useGrouping,
  }).format(roundedValue);
};

export default formatUpToTwoDecimalPlaces;
